import { ProblemSearchModalStatePresenter } from '@/presentation/presenters/problem/problemSearchModalStatePresenter'
import { ProblemSearchModalStateViewModel } from '@/presentation/viewmodels/problem/problemSearchModalStateViewModel'

export function useProblemSearchModalStatePresenter(
  presenter: ProblemSearchModalStatePresenter = new ProblemSearchModalStatePresenter(
    new ProblemSearchModalStateViewModel()
  )
) {
  return {
    modalState: presenter.modalState,
    selectedCourse: presenter.selectedCourse,
    selectedContestList: presenter.selectedContestList,
    setModalState: presenter.setModalState.bind(presenter),
    setSelectedCourse: presenter.setSelectedCourse.bind(presenter),
    setSelectedContestList: presenter.setSelectedContestList.bind(presenter)
  }
}
